// extracted by css-extract-rspack-plugin
export default {"container":"PaginationActions_container__agDux","buttonsWrapper":"PaginationActions_buttonsWrapper__Ka6nh"};